import { AddToDocumentHead } from "./AddToDocumentHead"

interface Props {
  icon: string
}

export const Favicon = ({ icon }: Props) => (
  <AddToDocumentHead>
    <link rel="icon" type="image/png" href={icon} sizes="16x16" />
  </AddToDocumentHead>
)
